/*
 * Copyright 2026 Christopher Moore
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { StyleOption } from '../types';

export const STYLES: StyleOption[] = [
  { label: 'No Style', value: '' },
  { label: 'Cyberpunk', value: ', cyberpunk style, neon lights' },
  { label: 'Anime', value: ', anime style, studio ghibli' },
  { label: 'Watercolor', value: ', watercolor painting, artistic' },
  { label: 'Photorealistic', value: ', photorealistic, 8k, cinematic' },
  { label: 'Oil Painting', value: ', oil painting, textured' },
  { label: '3D Render', value: ', 3d render, pixar style' },
  { label: 'Pixel Art', value: ', pixel art, 16-bit' },
  { label: 'Synthwave', value: ', synthwave, retrowave' },
  { label: 'Film Noir', value: ', film noir, b&w' },
  { label: 'Origami', value: ', origami style, paper' },
  { label: 'Comic Book', value: ', comic book style, bold' },
  { label: 'Line Art', value: ', continuous line drawing, minimalist' },
  { label: 'Surrealism', value: ', surrealism, salvador dali style' },
  { label: 'Claymation', value: ', claymation, stop motion, plasticine' },
  { label: 'Horror', value: ', lovecraftian, eldritch horror, dark' },
  { label: 'Isometric', value: ', isometric view, 3d, miniature' },
  { label: 'Low Poly', value: ', low poly, geometric, polygon art' },
  { label: 'Impressionist', value: ', impressionist painting, van gogh style' },
  { label: 'Steampunk', value: ', steampunk style, brass, gears' },
];
